import { Component } from '@angular/core';
import { CheckOnlineService } from '../../../core/providers/check-online.service';
import { TranslateService } from '@ngx-translate/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-noconnect',
    templateUrl: './noconnect.component.html',
    styleUrls: ['./noconnect.component.scss'],
    standalone: false
})
export class NoconnectComponent {
  text: string | null = null;
  showCloseButton = false;
  isOnline: boolean = false;

  readonly MIRA_NOT_AVAILABLE_TEXT = this.translator.instant('UI.Noconnect.Message.Backend|A mira jelenleg nem elérhető.');
  readonly INTERNET_NOT_AVAILABLE_TEXT = this.translator.instant('UI.Noconnect.Message.Internet|Internet nélkül a Mira sajnos nem használható.');
  readonly BACK_AGAIN_TEXT = this.translator.instant('UI.Noconnect.Message.Back-again|Mostmár úgy látjuk újra minden rendben.');

  readonly BACK_AGAIN_TIMEOUT = 2000;

  constructor(private checkOnlineService: CheckOnlineService,
    protected translator: TranslateService,
    private dialogRef: MatDialogRef<NoconnectComponent>
  ) {
    this.isOnline = false;
    this.setMessage();
    this.subscribeToConnectionEvents();
  }

  subscribeToConnectionEvents() {
    this.checkOnlineService.backendState$.subscribe(state => {
      this.setMessage();
    });
    this.checkOnlineService.connectivityState$.subscribe(state => {
      this.setMessage();
    });
  }

  setMessage() {
    if (
      this.checkOnlineService.connectivityState$.value === false ||
      this.checkOnlineService.backendState$.value === false) {
      if (this.checkOnlineService.connectivityState$.value === false) {
        this.isOnline = false;
        this.text = this.INTERNET_NOT_AVAILABLE_TEXT;
      } else {
        if (this.checkOnlineService.backendState$.value === false) {
          this.isOnline = false;
          this.text = this.MIRA_NOT_AVAILABLE_TEXT;
        }
      }
    } else {
      this.isOnline = true;
      this.text = this.BACK_AGAIN_TEXT;
      //this.showCloseButton = true;
      setInterval(() => {
        this.dialogRef.close();
      }, this.BACK_AGAIN_TIMEOUT);
    }
  }

  get stateIcon(): string {
    return this.isOnline
      ? 'cloud'
      : 'cloud_off';
  }
}
